import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { getProfile } from "../services/api";
import LogoutButton from "../components/LogoutButton";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #e8f0fe;
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

const ProfileCard = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
`;

const Title = styled.h1`
  font-size: 1.5rem;
  color: #080d44;
  margin-bottom: 1.5rem;
`;

const InfoRow = styled.div`
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--gray-color-light);

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

const Label = styled.span`
  font-weight: bold;
  color: #4a5568;
  margin-right: 0.5rem;
`;

const Value = styled.span`
  color: #2d3748;
`;

const ActionButton = styled(Link)`
  display: inline-block;
  background-color: #ff6b35;
  color: white;
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-weight: 600;
  margin-top: 1rem;
  text-align: center;
  
  &:hover {
    background-color: #e85a2a;
  }
`;

const EditButton = styled(Link)`
  display: inline-block;
  background-color: #080d44;
  color: white;
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-weight: 600;
  margin-top: 1rem;
  text-align: center;
  
  &:hover {
    background-color: #0a1a5e;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
`;

const ProfilePage = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getProfile();
        // Handle both old and new API response formats
        const userData = response.user || response;
        console.log("Profile data received:", userData);
        setProfile(userData);
      } catch (error) {
        console.error("Error fetching profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!profile) {
    return <div>Error loading profile</div>;
  }

  return (
    <PageContainer>
      <Header />
      <MainContent>
        <ProfileCard>
          <Title>Perfil de Usuario</Title>
          <InfoRow>
            <Label>Nombre:</Label>
            <Value>{profile.first_name || profile.nombre}</Value>
          </InfoRow>
          <InfoRow>
            <Label>Apellidos:</Label>
            <Value>{profile.last_name || profile.apellidos}</Value>
          </InfoRow>
          <InfoRow>
            <Label>Email:</Label>
            <Value>{profile.email}</Value>
          </InfoRow>
          <InfoRow>
            <Label>Teléfono:</Label>
            <Value>{profile.mobile_phone || profile.telefono || '-'}</Value>
          </InfoRow>
          
          <InfoRow>
            <Label>Identificación:</Label>
            <Value>{profile.id_number || profile.identificacion || '-'}</Value>
          </InfoRow>
          
          {/* Display lawyer information if available */}
          {(profile.lawyer_membership_number || profile.numColegiado) && (
            <InfoRow>
              <Label>Número de Colegiado:</Label>
              <Value>{profile.lawyer_membership_number || profile.numColegiado}</Value>
            </InfoRow>
          )}
          
          {(profile.province_name || profile.provinciaColegio) && (
            <InfoRow>
              <Label>Colegio de Abogados:</Label>
              <Value>{profile.province_name || profile.provinciaColegio}</Value>
            </InfoRow>
          )}
          
          <ButtonContainer>
            <EditButton to="/profile/edit">
              Editar Perfil
            </EditButton>
            <ActionButton to="/nueva-oferta">
              Nueva Oferta Vinculante
            </ActionButton>
            <ActionButton to="/offers">
              Ver Mis Ofertas
            </ActionButton>
            <LogoutButton />
          </ButtonContainer>
        </ProfileCard>
      </MainContent>
      <Footer />
    </PageContainer>
  );
};

export default ProfilePage;
